const homepage = {
  path: 'homepage',
  component: resolve => require(['../../../../components/pages/studentresults/homepage'], resolve)
}

export default homepage



// WEBPACK FOOTER //
// ./src/router/pages/studentresults/homepage/index.js